<template>
  <q-dialog
    v-model="dialogModel"
    color="secondary"
    :cancel="true"
    prevent-close
  >
    <span slot="title">{{ $t('cash_discount_dialog_header') }}</span>

    <span slot="message" v-html="$t('cash_discount_dialog_content')"></span>

    <div slot="body">
      <q-field class="q-field-force-input">
        <div class="row items-end no-wrap">
          <q-input
            v-model="cashDiscount.amount"
            style="width: 100px;"
            class="col-auto"
            name="discount"
            type="number"
            suffix="%"
            v-validate.disbale="'required'"
          />

          <div class="col text-center">
            <span>{{ $t('cash_discount_payment_until') }}</span>
          </div>

          <q-datetime
            v-model="cashDiscount.dateLimit"
            class="col-auto"
            type="date"
            name="cashDiscountLimit"
            v-validate.disbale="'required'"
            hide-underline
            :format="$t('date_format')"
          />
        </div>
      </q-field>
    </div>

    <template slot="buttons" slot-scope="props">
      <q-btn :label="$t('cancel')" flat @click="handleCancel(props.cancel)" />
      <q-btn :label="$t('ok')" :disabled="!hasDiscount" flat @click="handleAdd(props.ok)" />
    </template>
  </q-dialog>
</template>

<script>
  import { date } from 'quasar'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    data () {
      return {
        dialogModel: false,
        cashDiscount: {
          amount: 2.0,
          dateLimit: null
        }
      }
    },

    props: {
      invoiceDate: {
        type: [Date, String],
        required: true
      },

      dueDate: {
        type: [Date, String],
        required: false,
        default: null
      }
    },

    computed: {
      hasDiscount () {
        return this.cashDiscount.amount !== null && this.cashDiscount.dateLimit !== null
      }
    },

    methods: {
      open () {
        this.dialogModel = true

        if (this.dueDate) {
          const cashDiscountLimitSuggestion = Math.abs(Math.ceil(date.getDateDiff(this.invoiceDate, this.dueDate) / 2))
          this.cashDiscount.dateLimit = this.cashDiscountLimit || date.addToDate(this.invoiceDate, { days: cashDiscountLimitSuggestion })
        }
      },

      handleAdd (okFn) {
        if (this.hasDiscount) {
          this.$emit('discount', this.cashDiscount)
          this.resetData()
          okFn()
        }
      },

      handleCancel (cancelFn) {
        cancelFn()
        this.resetData()
      },

      resetData () {
        this.cashDiscount = {
          amount: 2.0,
          dateLimit: null
        }
      }
    }
  }
</script>
